export const BACKEND_URL = '/api';
